module.exports = __webpack_public_path__ + "img/1L8_212.8eec836a.png";